import React, { useEffect, useRef, useState } from "react";
import { CommonHeader } from "../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { InputTaxCredit, OutwardSupplies } from "../../components/Gst";
import RenderGstCard from "../../components/commons/ContentArea/RenderGstCard";
import "./styles.scss";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { ExpandMore, SwedishKronaSign } from "../../assets/images";
import { useParams } from "react-router-dom";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import {
  resetTotalInwardsListCount,
  resetTotalOutwardsListCount,
} from "../../redux/gstModule";
import { resetSession } from "../../redux/auth";
import GstrTwoB from "../../components/Gst/GstrTwoB/GstrTwoB";
import GstrTwoA from "../../components/Gst/GstrTwoA/GstrTwoA";

type AppProps = {
  token: string | null;
  history?: any;
  fetching: boolean;
  totalOutwardsListCount: number;
  totalInwardsListCount: number;
  dispatchResetTotalOutwardListCount: () => void;
  dispatchResetTotalInwardListCount: () => void;
};

interface TabsType {
  name: string;
  label: string;
  total: number;
}

const GSTModule = ({
  token,
  fetching,
  history,
  totalOutwardsListCount,
  totalInwardsListCount,
  dispatchResetTotalOutwardListCount,
  dispatchResetTotalInwardListCount,
}: AppProps) => {
  const { id } = useParams<any>();
  const activeUrlTab = history?.location?.state?.tabs;
  const client_code =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.client_code
      ? history.location.state.client_code
      : id
      ? id
      : null;

  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  const tabs: TabsType[] = [
    {
      name: "Outward Supplies",
      label: "Outward Supplies",
      total: totalOutwardsListCount,
    },
    {
      name: "Input Tax Credit",
      label: "Input Tax Credit",
      total: totalInwardsListCount,
    },
    {
      name: "GSTR 2A",
      label: "Gstr 2A",
      total: totalInwardsListCount,
    },
    {
      name: "GSTR 2B",
      label: "Gstr 2B",
      total: totalInwardsListCount,
    },
  ];
  const [finalTab, setFinalTab] = useState(tabs);
  const [activeTab, setActiveTab] = useState<string>(tabs[0].label);
  const [component, setComponent] = useState<any>();
  const [toggle, setToggle] = useState<boolean>(false);
  const [isGstrTwoA, setIsGstrTwoA] = useMenuCheck();
  const [isGstrTwoB, setIsGstrTwoB] = useMenuCheck();

  //====================User Managent=============================
  const [isGstrThreeBPresent, setIsGstrThreeBPresent] = useMenuCheck();
  //=================================================================

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
    history.push({
      pathName: `/gst/${client_code}`,
      state: { tabs, company_name, client_code },
    });
  };

  const handleSetIcon = () => {
    switch (client_code) {
      case 320:
      case 371:
      case 906:
      case 382:
      case 881:
      case 909:
      case 331:
      case 3871:
      case 3872:
        return (
          <i style={{ fontSize: "18px" }} className="las la-dollar-sign"></i>
        );
      case 907:
      case 880:
      case 184:
      case 3197:
        return (
          <i style={{ fontSize: "18px" }} className="las la-pound-sign"></i>
        );
      case 302:
        return <img src={SwedishKronaSign} className="swedish-icon" />;
      default:
        return (
          <i style={{ fontSize: "18px" }} className="las la-rupee-sign"></i>
        );
    }
  };

  useEffect(() => {
    if (activeUrlTab) {
      setActiveTab(activeUrlTab);
    }
  }, [activeUrlTab]);

  useEffect(() => {
    setIsGstrThreeBPresent("GSTR 3B", "menu");
    setIsGstrTwoA("Gstr 2A", "menu");
    setIsGstrTwoB("Gstr 2B", "menu");

    return () => {
      dispatchResetTotalOutwardListCount();
      dispatchResetTotalInwardListCount();
    };
  }, []);

  useEffect(() => {
    if (!isGstrTwoA && isGstrTwoB) {
      let newTab = tabs.filter((item: any) => item.label !== "Gstr 2A");
      setFinalTab(newTab);
    } else if (!isGstrTwoB && isGstrTwoA) {
      let newTab = tabs.filter((item: any) => item.label !== "Gstr 2B");
      setFinalTab(newTab);
    } else if (!isGstrTwoA && !isGstrTwoB) {
      const filteredTabs = tabs.filter(
        (tab) => tab.label !== "Gstr 2A" && tab.label !== "Gstr 2B"
      );
      setFinalTab(filteredTabs);
    } else if (isGstrTwoA && isGstrTwoB) {
      setFinalTab(tabs);
    }
  }, [isGstrTwoB, isGstrTwoA]);

  useEffect(() => {
    if (activeTab === "Outward Supplies") {
      setComponent(
        <OutwardSupplies history={history} handleSetIcon={handleSetIcon} />
      );
    }
    if (activeTab === "Input Tax Credit") {
      setComponent(
        <InputTaxCredit history={history} handleSetIcon={handleSetIcon} />
      );
    }

    // commented for future use
    if (activeTab === "Gstr 2A") {
      setComponent(<GstrTwoA history={history} />);
    }
    if (activeTab === "Gstr 2B") {
      setComponent(<GstrTwoB history={history} />);
    }
  }, [activeTab]);

  const renderTabs = () => {
    let finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          className={"tab-style mr-4"}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          <div className="d-flex">
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
              }}
              className={`tab-header mr-1 ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
            {/* commented for future use  */}
            {/* {tab?.total ? <div className={`gstr-box ${tab?.label == "Outward Supplies" ? "gstr-purple" : "gstr-light-blue"}`}>
                            {tab?.total}
                        </div> : null} */}
          </div>

          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTabs;
  };

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader
          title="GST"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="col-md-12">
        <>
          <div
            style={{
              background: "#d8dee4",
              borderRadius: "5px 5px 0 0",
              padding: "0px 15px",
            }}
          >
            <div
              className="d-flex"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <div className="d-flex">{renderTabs()}</div>

              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="select-gstr">Select GSTR Form Here : </div>
                <div style={{ width: "141px" }}>
                  <ButtonDropdown
                    isOpen={toggle}
                    toggle={() => {
                      setToggle(!toggle);
                    }}
                    className="download-report-btn"
                  >
                    <DropdownToggle
                      caret
                      color="secondary"
                      style={{
                        backgroundColor: "#dd4433",
                        color: "white",
                        border: "none",
                        fontSize: "13.5px",
                      }}
                      outline
                    >
                      GSTR FORMS
                      <span>
                        <img src={ExpandMore} alt="expand more" />
                      </span>
                    </DropdownToggle>

                    <DropdownMenu style={{ width: "100%", minWidth: "7px" }}>
                      <ul
                        style={{
                          listStyleType: "none",
                          padding: 0,
                          marginBottom: 0,
                        }}
                      >
                        <li
                          className="gstr_form_li"
                          onClick={() =>
                            history.push({
                              pathname: `/gst/gstr-one/${client_code}`,
                              state: { client_code, company_name },
                            })
                          }
                        >
                          GSTR - 1
                        </li>
                        {isGstrThreeBPresent && (
                          <li
                            className="gstr_form_li"
                            onClick={() =>
                              history.push({
                                pathname: `/gst/gstr-threeB/${client_code}`,
                                state: { client_code, company_name },
                              })
                            }
                          >
                            GSTR - 3B
                          </li>
                        )}
                        {/* for Future Use */}
                        {/*
                          <li className="gstr_form_li">GSTR - 2B</li>
                           <li className="gstr_form_li" >GSTR - 8</li>
                           <li className="gstr_form_li" >GSTR - 9</li>
                            <li className="gstr_form_li" >GSTR - 9C</li> */}
                      </ul>
                    </DropdownMenu>
                  </ButtonDropdown>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
      <RenderGstCard>{component}</RenderGstCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
  totalOutwardsListCount: state.gst.totalOutwardsListCount,
  totalInwardsListCount: state.gst.totalInwardsListCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetTotalInwardListCount: () =>
    dispatch(resetTotalInwardsListCount()),
  dispatchResetTotalOutwardListCount: () =>
    dispatch(resetTotalOutwardsListCount()),
  dispatchResetSession: () => dispatch(resetSession()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GSTModule);
